import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_customer_navigation = _resolveComponent("customer-navigation")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { theme: _ctx.theme }, {
    default: _withCtx(() => [
      _createVNode(_component_customer_navigation, { onCurrentPage: _ctx.setActivePage }, null, 8, ["onCurrentPage"]),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activePage)))
    ]),
    _: 1
  }, 8, ["theme"]))
}